import axios from "axios";

import {
  GET_COUNTRY,
  TOGGLE_COUNTRY,
  UPDATE_COUNTRY,
  ADD_COUNTRY,
  RESET_COUNTRY,
  LOADING
} from "../actionTypes";
import {
  AWS_LOCATION_8888,
  BASE_URL_LOCATION,
  IMAGE_URL,
  Who_Obj
} from "configurations";
import { adminToken } from "helper";

const { SET_TRUE, SET_FALSE } = LOADING;
export const get = () => {
  return dispatch => {
    dispatch({ type: SET_TRUE });
    adminToken()
      .then(token =>
        axios.get(`${AWS_LOCATION_8888}/country`, {
          headers: { Authorization: `Bearer ${token}` }
        })
      )
      .then(res => {
        dispatch({ type: GET_COUNTRY, payload: res.data });
      })
      .catch(err => console.log(err))
      .finally(_ => dispatch({ type: SET_FALSE }));
  };
};

export const add = name => {
  return async dispatch => {
    try {
      dispatch({ type: SET_TRUE });
      const token = await adminToken();
      const res = await axios.post(
        `${AWS_LOCATION_8888}/country`,
        {
          name,
          enabled: true
        },
        {
          headers: { Authorization: `Bearer ${token}` }
        }
      );

      dispatch({ type: ADD_COUNTRY, payload: res.data });
    } catch (err) {
      console.log(err);
    } finally {
      dispatch({ type: SET_FALSE });
    }
  };
};

// Update
export const update = (details = {}) => {
  const { name, displayName, description, displayOrder, id, image } = details;

  return async dispatch => {
    dispatch({ type: SET_TRUE });
    let imageRes;

    // Request to Upload Image
    if (typeof image === "object") {
      const formData = new FormData();
      formData.append("imageFile", image);
      imageRes = await axios.post(`${IMAGE_URL}`, formData, {
        headers: {
          "Content-Type": "multipart/form-data"
        }
      });
    }

    const finalRes = await axios.put(
      `${BASE_URL_LOCATION}/country/${id}`,
      {
        description,
        displayName,
        name,
        displayOrder: parseInt(displayOrder),
        image: imageRes?.data.imgUrl || image
      },
      {
        headers: { who: JSON.stringify(Who_Obj) }
      }
    );

    dispatch({ type: UPDATE_COUNTRY, payload: finalRes.data });
  };
};

export const toggle = id => {
  return async dispatch => {
    try {
      dispatch({ type: SET_TRUE });
      const token = await adminToken();
      const res = await axios.patch(
        `${AWS_LOCATION_8888}/country/${id}`,
        {},
        { headers: { Authorization: `Bearer ${token}` } }
      );

      dispatch({ type: TOGGLE_COUNTRY, payload: res.data });
    } catch (err) {
      console.log(err);
    } finally {
      dispatch({ type: SET_FALSE });
    }
  };
};

export const remove = id => {
  return dispatch => {
    dispatch({ type: SET_TRUE });
    axios
      .delete(`${BASE_URL_LOCATION}/country/${id}`, {
        headers: { who: Who_Obj }
      })
      .then(res => dispatch(get()))
      .catch(err => console.log(err))
      .finally(_ => dispatch({ type: SET_FALSE }));
  };
};

export const reset = () => dispatch => dispatch({ type: RESET_COUNTRY });
